module.exports = __webpack_public_path__ + "img/TradingView-img8.1e1e6b25.png";